
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import CandidateV3Custom, {
  CandidateV3Item,
  CandidateV3RemarkReq
} from "@/lib/model/exambuilder/candidate-v3/candidate-v3";
import { CandidateItem } from "@/lib/model/exambuilder/exam-component/candidate";

@Component({
  components: {}
})
export default class AddCandidateTags extends Vue {
  @Prop() selectedItem!: CandidateItem;
  @Prop({ default: false }) visible!: boolean;

  input = "";

  created() {
    this.input = this.selectedItem.remark;
  }

  submit() {
    CandidateItem.saveRemark(this.selectedItem.candidateId, this.input).then(
      () => {
        this.$message.success("添加成功");
        this.sure();
      }
    );
  }

  @Emit()
  cancel() {
    return true;
  }

  @Emit()
  sure() {
    return true;
  }
}
